import React from 'react';
import type { GeneralID, GetProps } from '@types';
import addComponent from '@utils/addComponent';
import SceneModal from './SceneModal';

type Params = Omit<GetProps<typeof SceneModal>, 'onRequestClose' | 'onConfirm'>;

function showSceneModal(props: Params): Promise<{ idSet?: Set<GeneralID> }> {
  return new Promise((resolve) => {
    addComponent((remove) => (
      <SceneModal
        {...props}
        onConfirm={(idSet) => {
          resolve({ idSet });
          remove();
        }}
        onRequestClose={() => {
          resolve({});
          remove();
        }}
      />
    ));
  });
}

export default showSceneModal;
